import { Component } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Jurisdiction } from '../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../shared/base-components/base.component';
import { BusinessTransactionOneTimeMailingAddressModel } from '../../shared/models/business-transaction/business-transaction-one-time-mailing-address.model';
import { BusinessTransactionService } from '../../shared/services/business-transaction/business-transaction.service';

@Component({
    selector: 'artifact-one-time-mailing-address',
    templateUrl: './artifact-one-time-mailing-address.component.html',
    inputs: ['tableTitle', 'transactionNumber']
})
export class ArtifactOneTimeMailingAddressComponent extends BaseComponent {
    public oneTimeMailingAddresses: BusinessTransactionOneTimeMailingAddressModel[];
    public dataLoaded: boolean;
    private transactionNumber: number;
    public tableTitle: string;
    private jurisdiction: Jurisdiction;

    constructor(
        private businessTransactionService: BusinessTransactionService,
    ) {
        super();
        this.dataLoaded = false;
        this.jurisdiction = new Jurisdiction();
    }

    async ngOnInit() {
        if (!this.transactionNumber) {
            this.dataLoaded = true;
            return;
        }

        // get business transaction metadata
        this.businessTransactionService.getOneTimeMailingAddress(this.transactionNumber)
            .pipe(finalize(() => this.dataLoaded = true))
            .subscribe(oneTimeMailingAddresses => {
                oneTimeMailingAddresses.forEach(x => x.jurisdictionCode = x.jurisdictionId ? this.jurisdiction.FromId(x.jurisdictionId).code : '');
                this.oneTimeMailingAddresses = oneTimeMailingAddresses;
            },
            (err) => {
                this.handleValidationResult(err);
            }
            );
    }
}
